import React from 'react';

export type SliderProps = {
  id: string;
  min: number | string;
  max: number | string;
  step: number | string;
  value: number | string;
  onChange: (e: number | string) => void;
  title: string;
  showLabel?: boolean;
};

function Slider({ id, min, max, step, value, onChange, title, showLabel = false }: SliderProps) {
  return (
    <div className="slider-wrapper">
      <label htmlFor={id} className={showLabel ? 'slider-label' : 'screen-reader-text'}>
        {title}
      </label>
      <input
        type="range"
        className="slider"
        id={id}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        title={title}
      />
    </div>
  );
}

export default Slider;
